import { render } from "./ThemeDropdown.vue?vue&type=template&id=0cd861ee"
import script from "./ThemeDropdown.vue?vue&type=script&lang=js"
export * from "./ThemeDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ThemeDropdown.vue"]])

export default __exports__